import { createGlobalStyle } from 'styled-components';

import { getStaticUrlAsset } from './utils/getStaticUrlAsset';

export const FontStyles = createGlobalStyle`
   /* CSS Reset for full viewport coverage */
   html,
   body {
    background-color: #faf9f5 !important;
    display: flex;
    flex-direction: column;
  }
  /* thin */
  @font-face {
    font-family: 'Calibre-R';
    font-weight: 100;
    font-style: normal;

    font-display: fallback;
    src: url('${getStaticUrlAsset('/fonts/Calibre-RWeb-Thin.eot?#iefix')}');
    src: url('${getStaticUrlAsset('/fonts/Calibre-RWeb-Thin.eot?#iefix')}') format('eot'),
      url('${getStaticUrlAsset('/fonts/Calibre-RWeb-Thin.woff2')}') format('woff2'),
      url('${getStaticUrlAsset('/fonts/Calibre-RWeb-Thin.woff')}') format('woff');
  }

  /* thin italic */
  @font-face {
    font-family: 'Calibre-R';
    font-weight: 100;
    font-style: italic;

    font-display: fallback;
    src: url('${getStaticUrlAsset('/fonts/Calibre-RWeb-ThinItalic.eot?#iefix')}');
    src: url('${getStaticUrlAsset('/fonts/Calibre-RWeb-ThinItalic.eot?#iefix')}') format('eot'),
      url('${getStaticUrlAsset('/fonts/Calibre-RWeb-ThinItalic.woff2')}') format('woff2'),
      url('${getStaticUrlAsset('/fonts/Calibre-RWeb-ThinItalic.woff')}') format('woff');
  }

  /* light */
  @font-face {
    font-family: 'Calibre-R';
    font-weight: 300;
    font-style: normal;

    font-display: fallback;
    src: url('${getStaticUrlAsset('/fonts/Calibre-RWeb-Light.eot?#iefix')}');
    src: url('${getStaticUrlAsset('/fonts/Calibre-RWeb-Light.eot?#iefix')}') format('eot'),
      url('${getStaticUrlAsset('/fonts/Calibre-RWeb-Light.woff2')}') format('woff2'),
      url('${getStaticUrlAsset('/fonts/Calibre-RWeb-Light.woff')}') format('woff');
  }

  /* light italic */
  @font-face {
    font-family: 'Calibre-R';
    font-weight: 300;
    font-style: italic;

    font-display: fallback;
    src: url('${getStaticUrlAsset('/fonts/Calibre-RWeb-Black.eot?#iefix')}');
    src: url('${getStaticUrlAsset('/fonts/Calibre-RWeb-LightItalic.eot?#iefix')}') format('eot'),
      url('${getStaticUrlAsset('/fonts/Calibre-RWeb-LightItalic.woff2')}') format('woff2'),
      url('${getStaticUrlAsset('/fonts/Calibre-RWeb-LightItalic.woff')}') format('woff');
  }

  /* regular */
  @font-face {
    font-family: 'Calibre-R';
    font-weight: 400;
    font-style: normal;

    font-display: fallback;
    src: url('${getStaticUrlAsset('/fonts/Calibre-RWeb-Regular.eot?#iefix')}');
    src: url('${getStaticUrlAsset('/fonts/Calibre-RWeb-Regular.eot?#iefix')}') format('eot'),
      url('${getStaticUrlAsset('/fonts/Calibre-RWeb-Regular.woff2')}') format('woff2'),
      url('${getStaticUrlAsset('/fonts/Calibre-RWeb-Regular.woff')}') format('woff');
  }

  /* regular italic */
  @font-face {
    font-family: 'Calibre-R';
    font-weight: 400;
    font-style: italic;

    font-display: fallback;
    src: url('${getStaticUrlAsset('/fonts/Calibre-RWeb-RegularItalic.eot?#iefix')}');
    src: url('${getStaticUrlAsset('/fonts/Calibre-RWeb-RegularItalic.eot?#iefix')}')
        format('eot'),
      url('${getStaticUrlAsset('/fonts/Calibre-RWeb-RegularItalic.woff2')}') format('woff2'),
      url('${getStaticUrlAsset('/fonts/Calibre-RWeb-RegularItalic.woff')}') format('woff');
  }

  /* medium */
  @font-face {
    font-family: 'Calibre-R';
    font-weight: 500;
    font-style: normal;

    font-display: fallback;
    src: url('${getStaticUrlAsset('/fonts/Calibre-RWeb-Medium.eot?#iefix')}');
    src: url('${getStaticUrlAsset('/fonts/Calibre-RWeb-Medium.eot?#iefix')}') format('eot'),
      url('${getStaticUrlAsset('/fonts/Calibre-RWeb-Medium.woff2')}') format('woff2'),
      url('${getStaticUrlAsset('/fonts/Calibre-RWeb-Medium.woff')}') format('woff');
  }

  /* medium italic */
  @font-face {
    font-family: 'Calibre-R';
    font-weight: 500;
    font-style: italic;

    font-display: fallback;
    src: url('${getStaticUrlAsset('/fonts/Calibre-RWeb-MediumItalic.eot?#iefix')}');
    src: url('${getStaticUrlAsset('/fonts/Calibre-RWeb-MediumItalic.eot?#iefix')}')
        format('eot'),
      url('${getStaticUrlAsset('/fonts/Calibre-RWeb-MediumItalic.woff2')}') format('woff2'),
      url('${getStaticUrlAsset('/fonts/Calibre-RWeb-MediumItalic.woff')}') format('woff');
  }

  /* semibold */
  @font-face {
    font-family: 'Calibre-R';
    font-weight: 600;
    font-style: normal;

    font-display: fallback;
    src: url('${getStaticUrlAsset('/fonts/Calibre-RWeb-Semibold.eot?#iefix')}');
    src: url('${getStaticUrlAsset('/fonts/Calibre-RWeb-Semibold.eot?#iefix')}') format('eot'),
      url('${getStaticUrlAsset('/fonts/Calibre-RWeb-Semibold.woff2')}') format('woff2'),
      url('${getStaticUrlAsset('/fonts/Calibre-RWeb-Semibold.woff')}') format('woff');
  }

  /* semibold italic */
  @font-face {
    font-family: 'Calibre-R';
    font-weight: 600;
    font-style: italic;

    font-display: fallback;
    src: url('${getStaticUrlAsset('/fonts/Calibre-RWeb-SemiboldItalic.eot?#iefix')}');
    src: url('${getStaticUrlAsset('/fonts/Calibre-RWeb-SemiboldItalic.eot?#iefix')}')
        format('eot'),
      url('${getStaticUrlAsset('/fonts/Calibre-RWeb-SemiboldItalic.woff2')}') format('woff2'),
      url('${getStaticUrlAsset('/fonts/Calibre-RWeb-SemiboldItalic.woff')}') format('woff');
  }

  /* bold */
  @font-face {
    font-family: 'Calibre-R';
    font-weight: 700;
    font-style: normal;

    font-display: fallback;
    src: url('${getStaticUrlAsset('/fonts/Calibre-RWeb-Bold.eot?#iefix')}');
    src: url('${getStaticUrlAsset('/fonts/Calibre-RWeb-Bold.eot?#iefix')}') format('eot'),
      url('${getStaticUrlAsset('/fonts/Calibre-RWeb-Bold.woff2')}') format('woff2'),
      url('${getStaticUrlAsset('/fonts/Calibre-RWeb-Bold.woff')}') format('woff');
  }

  /* bold italic */
  @font-face {
    font-family: 'Calibre-R';
    font-weight: 700;
    font-style: italic;

    font-display: fallback;
    src: url('${getStaticUrlAsset('/fonts/Calibre-RWeb-BoldItalic.eot?#iefix')}');
    src: url('${getStaticUrlAsset('/fonts/Calibre-RWeb-BoldItalic.eot?#iefix')}') format('eot'),
      url('${getStaticUrlAsset('/fonts/Calibre-RWeb-BoldItalic.woff2')}') format('woff2'),
      url('${getStaticUrlAsset('/fonts/Calibre-RWeb-BoldItalic.woff')}') format('woff');
  }

  /* black */
  @font-face {
    font-family: 'Calibre-R';
    font-weight: 800;
    font-style: normal;

    font-display: fallback;
    src: url('${getStaticUrlAsset('/fonts/Calibre-RWeb-Black.eot?#iefix')}');
    src: url('${getStaticUrlAsset('/fonts/Calibre-RWeb-Black.eot?#iefix')}') format('eot'),
      url('${getStaticUrlAsset('/fonts/Calibre-RWeb-Black.woff2')}') format('woff2'),
      url('${getStaticUrlAsset('/fonts/Calibre-RWeb-Black.woff')}') format('woff');
  }

  /* black italic */
  @font-face {
    font-family: 'Calibre-R';
    font-weight: 800;
    font-style: italic;

    font-display: fallback;
    src: url('${getStaticUrlAsset('/fonts/Calibre-RWeb-BlackItalic.eot?#iefix')}');
    src: url('${getStaticUrlAsset('/fonts/Calibre-RWeb-BlackItalic.eot?#iefix')}') format('eot'),
      url('${getStaticUrlAsset('/fonts/Calibre-RWeb-BlackItalic.woff2')}') format('woff2'),
      url('${getStaticUrlAsset('/fonts/Calibre-RWeb-BlackItalic.woff')}') format('woff');
  }
`;
